import { connect } from 'react-redux'
import MessageHeader from './presentational'

const mapStateToProps = (state) => ({
  profile: state.profile.payload,
})

export default connect(mapStateToProps)(MessageHeader)
